import React, { useState, useRef } from "react";

import { trackPromise } from "react-promise-tracker";

import { Modal, message } from "antd";

import { gerenciarLink } from "../../services/http/linkCompartilhado";

import IconeArquivos from "../IconeArquivos";

import infoPastaSvg from "../../assets/icons/infoPasta.svg";

import "./styles.scss";
import { Bolt, CloseOutlined } from "@mui/icons-material";
import anexar from "../../assets/icons/iconLink.svg";
const ModalGerarLinkUnico = ({ linkGerado, closeModal, openModal }) => {
  const [dataValidade, setDataValidade] = useState("Indefinida");
  const [senha, setSenha] = useState("Indefinida");
  const [modalAlterar, setModalAlterar] = useState(false);
  const [tipoAlteracao, setTipoAlteracao] = useState(null);

  const IncluirDataSenhaLinkUnico = () => {
    if (tipoAlteracao == "d") {
      if (dataValidade == "Indefinida" || !dataValidade) {
        message.warning("Preencha o campo da data de validade");
        return;
      } else {
        message.success("Data de validade atualizada com sucesso");
      }
    }

    if (tipoAlteracao == "s") {
      if (senha == "Indefinida" || !senha) {
        message.warning("Preencha o campo de senha");
        return;
      } else {
        message.success("Senha atualizada com sucesso");
      }
    }

    linkGerado.forEach((link) => {
      let dataConvertida = `${dataValidade.split("/")[2]}-${
        dataValidade.split("/")[1]
      }-${(parseInt(dataValidade.split("/")[0]) + 1)
        .toString()
        .padStart(2, "0")}`;

      let data = {
        idLinkCompartilhado: link.idLinkGerado,
        dataValidade:
          dataValidade == "Indefinida" || !dataValidade ? null : dataConvertida,
        senhaAcesso: senha == "Indefinida" || !senha ? null : senha,
      };

      trackPromise(
        gerenciarLink(data)
          .then((res) => {
            if (!res.fail) {
              closeModalAlterar();
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    });
  };

  const copiarTexto = (id) => {
    let inputId = `#input${id}`;
    let input = document.querySelector(inputId);
    input.select();
    document.execCommand("copy");
    message.success("Link copiado com sucesso!");
  };

  const handleChangeDate = (e) => {
    setDataValidade(new Date(e.target.value).toLocaleDateString());
  };

  const handleAlterarData = () => {
    closeModalAlterar();
    setTipoAlteracao("d");
    showModalAlterar();
  };

  const handleAlterarSenha = () => {
    closeModalAlterar();
    setTipoAlteracao("s");
    showModalAlterar();
  };

  const showModalAlterar = () => {
    setModalAlterar(true);
  };
  const closeModalAlterar = () => {
    setModalAlterar(false);
  };

  const mostrarIconePastaArquivo = (item) => {
    if (item.tipo == 0) {
      return <img src={infoPastaSvg} />;
    } else {
      if (item.urlPreview) {
        return <img src={item.urlPreview} />;
      } else {
        return (
          <IconeArquivos
            tamanho={"P"}
            tipo={String(item.nomeDocumento).split(".")[1]}
          />
        );
      }
    }
  };

  return (
    <div>
      <Modal
        title={<span className="modal-title-obterLink">Obter link</span>}
        visible={openModal}
        className="modal-obterLinkNovo"
        closable={false}
        destroyOnClose={true}
        footer={[]}
      >
        <CloseOutlined onClick={closeModal} className="custom-close-icon" />
        <div>
          <div className="container-alterar-data-senha mt-2">
            <div className="container-data-senha">
              <span className="info-senha-data">
                Data de validade:{" "}
                <span>
                  {linkGerado[0].dataValidade && dataValidade == "Indefinida"
                    ? linkGerado[0].dataValidade
                    : dataValidade == "Indefinida"
                    ? "Indefinida"
                    : `${(parseInt(dataValidade.split("/")[0]) + 1)
                        .toString()
                        .padStart(2, "0")}/${dataValidade.split("/")[1]}/${
                        dataValidade.split("/")[2]
                      }`}
                </span>
              </span>
              <span className="info-senha">
                Senha de acesso:{" "}
                <span>
                  {linkGerado[0].senha || senha != "Indefinida"
                    ? "******"
                    : "Indefinida"}
                </span>
              </span>
            </div>
            <div className="container-button-senha-data">
              <button onClick={handleAlterarData}>
                Definir uma data de validade
              </button>
              <button onClick={handleAlterarSenha}>Definir uma senha</button>
            </div>
          </div>
          <div className="container-link-gerado">
            {linkGerado.map((item, index) => {
              const nomeDocumento =
                item.nomeDocumento.length > 20
                  ? item.nomeDocumento.slice(0, 17) + "..."
                  : item.nomeDocumento;

              return (
                <div className="container-info-link" key={index}>
                  <div className="container-info-item-original">
                    {mostrarIconePastaArquivo(item)}
                    <span className="nome-item" title={item.nomeDocumento}>
                      {nomeDocumento}
                    </span>
                    <span className="tamanho-item">
                      {item.tamanho > 0 ? item.tamanho : ""}
                    </span>
                    <span
                      style={{
                        color: "#0042DD",
                        fontWeight: "normal",
                        margin: "5px 20px 0 20px",
                      }}
                    >
                      {"Pastas: " + item.tamanhoPastas}
                    </span>

                    <span
                      style={{
                        color: "#0042DD",
                        fontWeight: "normal",
                        margin: "5px 20px 0 20px",
                      }}
                    >
                      {"Tamanho: " + item.tamanhoTotalPastas}
                    </span>
                  </div>
                  <div className="container-copiar-link">
                    <img className="anexar" src={anexar} alt="anexar" />
                    <input
                      className="w-100"
                      id={`input${index}`}
                      value={item.linkGerado}
                      readOnly
                    />

                    <button
                      className="button-copiar-obter "
                      onClick={() => copiarTexto(index)}
                    >
                      COPIAR
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Modal>

      <Modal
        visible={modalAlterar}
        className="modal-definir-senha-data"
        closable={false}
        destroyOnClose={true}
        footer={false}
      >
        <CloseOutlined
          onClick={closeModalAlterar}
          className="custom-close-icon"
        />
        <div className="container-input-senha-data">
          {tipoAlteracao == "d" ? (
            <div>
              {" "}
              <labe>Data de validade</labe>{" "}
              <input
                className="input-data mt-3"
                type="date"
                onChange={(e) => handleChangeDate(e)}
              />{" "}
            </div>
          ) : (
            <div>
              {" "}
              <labe>Senha</labe>{" "}
              <input
                className="input-senha mt-3"
                type="password"
                onChange={(e) => setSenha(e.target.value)}
              />{" "}
            </div>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <button
              className="btn-salvar-senha-data"
              onClick={IncluirDataSenhaLinkUnico}
            >
              Salvar
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ModalGerarLinkUnico;
